import styled from 'styled-components';

import { StatusScreenButton } from '../statusScreen/StatusScreen.styles';

const InProgressStatusScreenButton = styled(StatusScreenButton)`
  height: 2.5rem;
  @media (max-width: 768px) {
    height: 3.375rem;
  }

  .recovery-payment-button {
    margin-top: 0;
  }
`;

export default InProgressStatusScreenButton;
